import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
//import exchangeCoin from "../../assets/images/exchange-coin.gif";
import exchangeCoin from "./../../assets/images/informativewall/transfer.gif";
/*import { SiBitcoin } from "react-icons/si";
import deriv from "../../assets/images/deriv-icon.png";
import colombia from "../../assets/images/colombia.png";
import usa from "../../assets/images/usa.png";*/
import Select from "react-select";
import { CashierProcessor, DepositForm, Proccesor } from "../../types";
import APIService from "../../services/Api";
import { useForm } from "react-hook-form";
import FormRequired from "../Shared/FormRequired";
import {
  SelectWithdrawOptions,
  classNames,
  encriptarString,
  getProfileDefaultImage,
  money,
  moneyInput,
  selectStyle,
} from "../../helpers/mixins";
import { FaLock } from "react-icons/fa";
import React from "react";
import RegisterForm from "../Register/RegisterForm";
import DialogInfoGeneral from "../Shared/DialogInfoGeneral";

type ISelect = {
  value: string | undefined;
  label: string;
  image: string;
};

type ParamsSimulateMoney = {
  fullname?: string;
  nickname?: string;
  cashierId: string;
  footerClass?: string;
  photo?: string;
  timePayment?: string;
  cashierProcessors?: CashierProcessor[];
};
const SimulateMoney = ({
  fullname,
  cashierId,
  footerClass,
  photo,
  nickname,
  cashierProcessors,
  timePayment,
}: ParamsSimulateMoney) => {
  const { t } = useTranslation();
  const [loadingCalculate, setLoadingCalculate] = useState<boolean>(false);
  const [useDestiny, setUseDestiny] = useState("");
  const [showRegister, setShowRegister] = useState<boolean>(false);
  const formRef = React.useRef<HTMLFormElement>(null);
  const [cashierProcessor, setCashierProcessor] = useState<Proccesor[]>([]);
  const [processors, setProcessors] = useState<Proccesor[]>([]);
  const [notRange, setNotRange] = useState<string>("");
  const [totalToPay, setTotalToPay] = useState<string>();
  const [needValidate, setNeedValidate] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [needRecalculate, setNeedRecalculate] = useState<boolean>(true);
  const [moneyCalc, setMoneyCalc] = useState<string>('')
  const [loadingFetch, setLoadingFetch] = useState<boolean>(false);

  const fetchCashierListProcessor = async () => {
    setLoadingFetch(true);
    let response = await APIService.calculatorListProcessors({ cashierId });
    response = response?.data?.data?.processors || [];
    setCashierProcessor(response);
    setProcessors(response);
    setLoadingFetch(false);
  };

  useEffect(() => {
    if (cashierId && !cashierProcessor.length) {
      fetchCashierListProcessor();
    }
  }, [cashierId]);

  const [optionsDestiny, setOptionsDestiny] = useState<ISelect[]>([]);
  const {
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<DepositForm>();

  useEffect(() => {
    const optionsDestiny2 = cashierProcessor.map((p) => ({
      value: p?.id,
      label: p?.name?.toUpperCase(),
      image: `${process.env.REACT_APP_PROCESSOR_IMAGE}${p?.photoUrl}`,
    }));
    setOptionsDestiny(optionsDestiny2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashierProcessor]);

  const handleSelect = (type: string, e: any) => {
    switch (type) {
      case "destiny":
        setValue("destiny", e.value);
        setUseDestiny(e.value);
        setTotalToPay(undefined);
        break;
      case "origen":
        setValue("origen", e.value);
        setUseDestiny("");
        setTotalToPay(undefined);
        const origenFiat = getFiatName(e.value);
        let tempProcessors = [...cashierProcessor?.filter((c) => c.status)];
        //para cualquier Fiat distinto a USD no está permitido q el origen y el destino contengan mismo tipo de Fiat
        if ((origenFiat || "").toUpperCase() !== "USD") {
          tempProcessors = tempProcessors
            .filter((p) => p.status === "active")
            .filter((p) => p?.systemFiat?.name !== (origenFiat || ""));
        }
        const optionsDestiny2 = tempProcessors
          .filter((p) => p.id !== e.value)
          .filter((p) => p.status === "active")
          .map((p) => ({
            value: p.id,
            label: p?.name?.toUpperCase(),
            image: `${process.env.REACT_APP_PROCESSOR_IMAGE}${p.photoUrl}`,
          }));

        setOptionsDestiny(optionsDestiny2);
        //setNeedReCalculate(true)
        break;
      case "accountsend":
        setValue("accountsend", e.value);
      //@ts-ignore
    }

    formRef.current?.dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  const origenOptions = () => {
    //return processors?.filter(p => p.id !== getValues('destiny')).map(p => ({
    return cashierProcessor?.map((p) => ({
      value: p?.id,
      label: p?.name.toUpperCase(),
      image: `${process.env.REACT_APP_PROCESSOR_IMAGE}${p?.photoUrl}`,
    }));
  };
  const validateSendCalculate = () => {
    return getValues("money") && getValues("destiny") && getValues("origen");
  };

  const getFiatName = (id: any) => {
    return processors?.find((p) => p?.id === id)?.systemFiat?.name || "";
  };
  const changeValue = (e: React.ChangeEvent<HTMLInputElement>) => {

    let { value } = e.target;
    value = value.replaceAll(".", "");
   value = (value.replace(/\D/g, ""));

    setNeedRecalculate(true);

    setValue("money", value);
    setMoneyCalc(value)
    /*formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))*/
  };

  const goForm = () => {
    setNeedValidate(true);
    formRef.current?.dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };
  const handleCalculate = async (data: DepositForm) => {
    if (validateSendCalculate()) {
      setLoadingCalculate(true);
      const calculate = await APIService.transferCalculate({
        ...data,
        cashierId: encriptarString(cashierId),
      });
      setNotRange("");
      if (calculate.data.status) {
        setTotalToPay(calculate.data.data.totalToPay);
        //setTypeMovement(calculate.data.data.rangePrices.systemProcessor.type);
        //agregar deposito al contexto
        setSuccess(true);
        setNeedRecalculate(false);
      } else {
        setNotRange("failed");
        setTotalToPay("0");
        setSuccess(false);
      }
      setLoadingCalculate(false);
    }
  };


  const ContentRegister = () => {
    return (
      <div>
        <RegisterForm />
      </div>
    );
  };

  // Good: Custom component declared outside of the Select scope
  /*   const Control = ({ children, ...props }: ControlProps<false>) => {
    // @ts-ignore
    //const { emoji, onEmojiClick } = props.selectProps;
    const style = { cursor: 'pointer' };
  
    return (
      <components.Control {...props}>
        <span  style={style}>
          oelo
        </span>
        {children}
      </components.Control>
    );
  };
 */

  return (
    <div className="text-center text-2xl sm:text-2xl bg-gradient-card simulate-money mb-10">
      <div className="w-full justify-start items-center mb-8 md:mb-0 gap-6 rounded-sm  h-fit">
        {fullname && (
          <div className="bg-white text-black font-normal text-sm mb-1 px-2 py-2 rounded-md flex flex-wrap items-center gap-2">
            <div
              className="w-10 h-10  bg-cover bg-center rounded-full"
              style={{
                backgroundImage: `url(${
                  (photo?.length || 0) > 0
                    ? process.env.REACT_APP_PROFILEPICTURE + (photo || "")
                    : getProfileDefaultImage()
                })`,
              }}
            ></div>
            <div className="text-left">
              <div className="font-semibold uppercase text-base">{fullname}</div>
              {nickname && (
                <div className="font-semibold text-sm uppercase">{nickname}</div>
              )}
            </div>
          </div>
        )}
        {cashierProcessors?.filter(
          (p) => p.status === "active" && (p.enabledeposit || p.enablewithdraw)
        ) && (
          <div className="opensans text-sm py-2 bg-white font-bold">
            Procesadores activos
          </div>
        )}
        <div>
          {timePayment &&
            <div className="text-xs text-center bg-white text-center">
              Tiempo promedio de pago {timePayment} minutos.
            </div>
            }
        </div>
        {(cashierProcessors?.length || 0) > 0 && (
          <div className="flex flex-wrap items-center justify-center md:justify-start bg-white ">
            {cashierProcessors
              ?.filter(
                (p) =>
                  p.status === "active" && (p.enabledeposit || p.enablewithdraw)
              )
              ?.map((c, key) => (
                <div key={key.toString()}>
                  <img
                    src={`${process.env.REACT_APP_PROCESSOR_IMAGE}${c?.systemProcessor?.photoUrl}`}
                    alt={c?.systemProcessor?.name}
                    className="w-20 h-auto"
                  />
                </div>
              ))}
          </div>
        )}
        {/*         <div className="w-full top">
          <div className="mb-8 fadeintop w-full lg:w-fit font-medium text-sm md:text-sm px-2 uppercase  mx-auto flex items-center gap-x-1 bg-title-simulate rounded-lg">
            <img src={exchangeCoin} className="w-10" alt="exchange" />
            <div className="text-center text-sm">
              {t("calc.title3")}
            </div>
          </div>           
        </div>
   */}
        <section className="text-sm px-8 py-4 opensans">
          <form
            ref={formRef}
            onSubmit={handleSubmit(handleCalculate)}
            className="mt-2 w-full"
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-5 h-auto">
              <div className="col-span-2 lg:col-span-1 text-black">
                <div className="text-sm font-bold text-black bg-white py-2 rounded-md mb-1">
                  {" "}
                  {t("paymentmethodtext")}{" "}
                </div>
                <Select
                  isSearchable={true}
                  options={origenOptions()}
                  components={{ Option: SelectWithdrawOptions }}
                  styles={selectStyle}
                  onChange={(e: any) => handleSelect("origen", e)}
                  placeholder={`${t("selectlist")}`}
                />
                {needValidate && !getValues("origen") && (
                  <div className="bg-white w-full mt-2 px-2 py-2 rounded-md ">
                    <FormRequired />
                  </div>
                )}
              </div>
              <div className="col-span-2 lg:col-span-1 text-black">
                <div className="text-sm font-bold text-black bg-white py-2 rounded-md mb-1">
                  {" "}
                  {t("needgetdestinytext")}{" "}
                </div>
                {(processors?.length || 0) > 0 && (
                  <Select
                    isSearchable={true}
                    options={optionsDestiny}
                    components={{ Option: SelectWithdrawOptions }}
                    styles={selectStyle}
                    value={{
                      label:
                        processors
                          ?.find((p) => p.id === useDestiny)
                          ?.name?.toUpperCase() || "-",
                      value:
                        processors?.find((p) => p.id === useDestiny)?.id ||
                        undefined,
                    }}
                    onChange={(e: any) => handleSelect("destiny", e)}
                    placeholder={`${t("selectlist")}`}
                  />
                )}
                {needValidate && !getValues("destiny") && (
                  <div className="bg-white w-full mt-2 px-2 py-2 rounded-md ">
                    <FormRequired />
                  </div>
                )}
              </div>
              <div className="col-span-2 lg:col-span-1 text-black">
                <div className="text-sm font-bold text-black bg-white rounded-md mb-1 py-2">
                  {" "}
                  {t("willsend")} {getFiatName(getValues("origen"))}
                </div>
                <input
                  onChange={changeValue}
                  type='text'
                  max={22}
                  inputMode="numeric" 
                  pattern="[0-9]*" 
                  maxLength={22}
                  value={moneyInput(moneyCalc)}
                  className="text-sm font-semibold py-4 px-2 border border-neutral-300 rounded-md w-full"
                  placeholder="$ ingresa cantidad"
                />
                {(errors.money || (needValidate && !getValues("money"))) && (
                  <div className="bg-white w-full mt-2 px-2 py-2 rounded-md ">
                    <FormRequired />
                  </div>
                )}
              </div>
              <div className="col-span-2 lg:col-span-1 text-black">
                <div className="text-sm font-bold text-black bg-white rounded-md mb-1 py-2">
                  {t("youget")} ${getFiatName(getValues("destiny"))}
                </div>
                {!loadingCalculate ? (
                  <div className="text-sm font-semibold py-4 px-2 border border-neutral-300 rounded-md w-full cursor-default bg-white text-black h-12">
                    {money(totalToPay || '')}

                  </div>
                ) : (
                  <div className="skeleton-loading w-full">
                    <div
                      className="loading-block-dark"
                      style={{ width: "50%", height: "3rem" }}
                    >
                      &nbsp;
                    </div>
                  </div>
                )}
              </div>
              {needRecalculate && (
                <div className="col-span-2">
                  <button
                    type="button"
                    onClick={() => goForm()}
                    className="bg-yellow-400 fadeinbottom text-black font-semibold rounded-sm text-center px-6 py-1.5 text-base "
                  >
                    Calcular
                  </button>
                </div>
              )}
            </div>
          </form>
          {notRange === "failed" && (
            <div className="text-red-400 py-2 font-bold text-base opensans bg-black border border-red-400 rounded-md w-full  px-2 mt-2">
              {t("deposits.notrange")}
            </div>
          )}
        </section>

        <div className="flex w-full opensans lg:flex-row justify-center text-sm text-white tex items-center gap-x-4 mb-2">
          <div
            className={classNames(
              "text-center w-full",
              footerClass ? ` ${footerClass} ` : `text-white`
            )}
          >
            <div className="flex items-center justify-center bg-[#0000001f] gap-2 px-6 mb-2 font-medium rounded-sm w-fit mx-auto">
              {t("securetran")} <FaLock size={15} />
            </div>
            <div className="font-medium uppercase text-xs bg-[#0000001f] w-fit mx-auto rounded-sm px-2 py-2 rounded-md">
              {t("certifyOne")} {new Date().getFullYear() - 2014} {t("years")}
            </div>
          </div>
        </div>

        {/* <div className="w-full flex items-center  justify-center mt-3">
          {!isAuthenticated ? (
            <div onClick={() => setShowRegister(true)}>
              <button className="bg-red-500 text-black px-6 py-1 rounded-md">
                Crear cuenta
              </button>
            </div>
          ) : (
            <Link to="/transferir">
              <button className="bg-red-500 text-black px-2 py-1 rounded-md">
                {t("createtransfer")}
              </button>
            </Link>
          )}
        </div>*/}
      </div>

      <div className=" gap-6 w-11/12 mx-auto font-semibold">
        {/*<div className="w-full   flex flex-col justify-around">
          <div className="font-medium text-center text-black px-4 py-4 black-patch grid grid-cols-2">
            <div className="col-span-2  text-xl tracking-wide font-light items-center justify-center flex">
              <ul className="mb-0 flex flex-col gap-2">
                <li>{t("calc.title1")}</li>
                <li className="flex items-center justify-center">
                  <AiFillSafetyCertificate size={43} />
                </li>
                <li>{t("calc.title2")}</li>
              </ul>
            </div>
          </div>
          <div className="text-base mt-2 md:mt-0 text-center md:text-left text-black px-4 py-4 black-patch font-medium grid grid-cols-2">
            <div className="text-xs col-span-2">
              <ul className="mb-0 flex flex-col gap-2">
                <li className="font-normal text-xl flex items-center justify-center">
                  {t("calc.text1")}
                </li>
                <li>
                  <img
                    src={moneyFlow}
                    className="w-10 md:w-12 rounded-4xl mx-auto"
                    alt="animacion"
                  />
                </li>
                <li className="font-normal text-lg flex items-center justify-center">
                  {t("calc.text2")}
                </li>
              </ul>
            </div>
          </div>
          </div>*/}
      </div>
      <DialogInfoGeneral
        disabledFooter={true}
        size={"xl"}
        show={showRegister}
        closeDialog={() => setShowRegister(false)}
        children={<ContentRegister />}
      />
    </div>
  );
};
export default SimulateMoney;
